import { useEffect } from 'react';
import { setPageMeta } from '../utils/seo';
import content from '../content/siteContent.json';

const Services = () => {
  const { services } = content;

  useEffect(() => {
    setPageMeta({ title: services.meta.title, description: services.meta.description });
  }, []);

  return (
    <div className="page">
      <section className="grid">
        <div className="section-title">
          <p className="eyebrow">{services.works.eyebrow}</p>
          <h1>{services.works.title}</h1>
          <p className="section-lead">{services.works.lead}</p>
        </div>
        <div className="card-grid">
          {services.works.list.map((work) => (
            <article className="card service-card" key={work.title}>
              <h2>{work.title}</h2>
              <p>{work.desc}</p>
              <ul className="list inline">
                {work.features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Services;
